import { Link, useLocation } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button } from '@/components/button';

export function NotFound() {
  const { pathname } = useLocation();

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="max-w-sm space-y-4 text-center">
        <div className="inline-flex size-12 items-center justify-center rounded-full bg-[var(--color-surface-muted)]">
          <Compass className="size-6 text-[var(--color-foreground-muted)]" />
        </div>
        <div>
          <h1 className="text-xl font-semibold tracking-tight">Page not found</h1>
          <p className="mt-1 text-sm text-[var(--color-foreground-muted)]">
            <code className="rounded bg-[var(--color-surface-muted)] px-1.5 py-0.5 text-xs">
              {pathname}
            </code>{' '}
            isn't a page in this app.
          </p>
        </div>
        <Link to="/">
          <Button variant="secondary">Back to dashboard</Button>
        </Link>
      </div>
    </div>
  );
}
